var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v("\n\t\t\tHandelsbetingelser\n\t\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Ved at benytte dig af Virksomhedens juridiske navn services og produkter accepterer du samtidig nedenstående Handelsbetingelser. Læs dem derfor grundigt.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\t\tOm Virksomheden\n\t\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n            " + _vm._s(_vm.merchant.name) + "\n        ")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n            " + _vm._s(_vm.merchant.vat) + "\n        ")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            " +
          _vm._s(_vm.merchant.address) +
          ", " +
          _vm._s(_vm.merchant.zip) +
          " " +
          _vm._s(_vm.merchant.city) +
          "\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n            " + _vm._s(_vm.merchant.email) + "\n        ")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n            " + _vm._s(_vm.merchant.phone) + "\n        ")
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\t\t    Almene bestemmelser\n\t\t    ")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Ved bestilling og betaling af abonnement eller produkter hos " +
          _vm._s(_vm.merchant.name) +
          ", (herefter kaldet Leverandøren) accepterer køber (herefter kaldet Kunden) nærværende Handelsbetingelser. Accept sker ved afkrydsning af handelsbetingelser under tilmelding/betaling/valg af produkt på Zietwing.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Leverandøren har ret til at tilføje egne betingelser til disse obligatoriske Handelsbetingelser som ikke kan ændres eller til sidestilles. De gældende Handelsbetingelser accepteres af Kunden, før en aftale indgås mellem Leverandøren og Kunden. Det påhviler Kunden til enhver tid at holde sig ajour med de gældende Handelsbetingelser, hvilke er tilgængelige på Zietwing platformen, når der bestilles et produkt.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Enhver tvist imellem leverandøren og kunden er underlagt Dansk lovgivning.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [
      _vm._v(
        "\n\t\t\t\t  Accept af abonnementsbetingelser og køb af produkter\n\t\t    "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Ved kundens tilmelding og valg af leverandørens produkter, accepterer kunden at Leverandøren, må trække det aftalte beløb periodevis i overensstemmelse med det valgte produkt og trækningsperiode/dato. Når kunden køber abonnement/produkter gennem Leverandøren på Zietwing platformen, fornyes dette automatisk indtil kunden afmelder sig skriftligt via leverandøren, eller ved at slette abonnement/produkt via kundens brugerlogin på Zietwing platformen.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Ved kundens tilmelding accepteres yderligere, at Leverandøren har ret til at ændre abonnements/produkt pris til enhver tid. Ændring i produkt varsles på til kunden på e-mail. Betaling sker løbende i henhold til forhandlerens trækningsdato, som godkendes af kunden ved accept af produkt/abonnement.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\t      Leverandørens ydelse\n\t      ")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Leverandøren leverer til kunden en nem løsning gennem Zietwing, til betaling af abonnement/produkter hos leverandøren. Systemet er tilgængeligt online og til kunden er der et login med følgende funktioner indenfor betaling:\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            - Allerede aktiveret betalingskort kan aflæses og slettes.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n            - Der kan skiftes til nyt betalingskort.\n        ")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            - Der vises alle forudgående betalinger, samt fremtidige betalinger.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            - Der kan hentes fakturaer på alle gennemførte betalinger\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            - Eventuelle abonnementer kan de-aktiveres/slettes.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tBetalingstjeneste\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Leverandøren tilbyder sine Kunder, at de kan betale abonnement/produkter online gennem Zietwing platformen, såfremt de har tilmeldt sig denne service og er blevet godkendt. Dvs. at kunderne kan betale med fx Dankort, Visa og MasterCard med mere, via Leverandørens egen betalingsaftale med betalingsinstituttet og Zietwing betalingstjenesten.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n            Der kan betales med følgende kort:\n        ")
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Kortnummer og udløbsdatoen finder man altid på forsiden af sit betalingskort. Kortnummer indtastes altid uden mellemrum. Kontrolcifre (CVV kode) finder man på bagsiden af sit kort og skal indtastes første gang kunden aktiverer sin bruger profil.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Kunden køber ydelsen/produktet af Leverandøren og Leverandøren kan vælge at indeholde det periodevise Abonnementsgebyr, administrationsgebyr samt eventuelle indkøbte ekstra ydelser i prisen, eller vælge at dette vises særskilt. Ydermere kan leverandøren vælge hvorvidt kunden skal betale gebyret for selve kort transaktionen.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tIdentitet og betalingsansvar\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Ved tilmelding hos Leverandøren skal kunden tiltræde med korrekte oplysninger om identitet og validering af betalingskort udføres for at sikre, at oplysninger om Kunden er sandfærdige, samt betalingskort er aktivt og har dækning for eventuelle køb.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Validering foregår ved at der foretages en live autorisation på kundens kort. Ved godkendt autorisation aktiveres kundens kort som godkendt betalingsmiddel i Zietwing platformen og kan benyttes fremadrettet.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Ved benyttelse af Visa dankort/dankort eller Visa og MasterCard indestår Kunden for – og er garant for – at kunden har den identitet, som dennes kunde angiver, samt at kunden ejer det betalingskort som benyttes ved køb.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Såfremt der er tale om en evt. “charge back” (dvs. en kunde, som har betalt med et kreditkort og efterfølgende afviser betalingen) fra Leverandørens tredjepart (fx Nets/indløser), er Kunden ansvarlig for straks at betale det beløb, som tredjepart forlanger, uanset årsag. Kunden forsikrer, at dennes identitet er korrekt og rigtig, samt at Kunden ikke misbruger betalingskort. Såfremt at “fraud”/misbrug alligevel skulle ske, er det Kundens ansvar og pligt at tilbagebetale Leverandøren det beløb, som der er blevet gennemført, således at Leverandøren står uforandret.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\t      Pris og betalingsbetingelser\n\t      ")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Alle priserne er angivet i danske kroner og er inkl. moms. Ændringer i valutakurser, afgifter, forsikring, nettoprisindekset, fragt og indkøbsomkostninger medfører, at Leverandøren kan justere priserne, således at Leverandøren stilles uændret.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Taksering/gebyrer sker i overensstemmelse med Leverandørens til enhver tid gældende gebyrer.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [
      _vm._v(
        "\n\t\t\t    Procedure for fornyelse og sletning af kortnummer\n\t      "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Bliver kundens kort lukket, fordi kunden har fået et nyt eller af anden årsag, vil betaling ikke kunne gennemføres og kunden vil pr. mail blive informeret omkring manglende betaling. Ønsker kunden, at betalingen skal trækkes fra et andet betalingskort, skal kunden aktiverer det nye kort i sin brugerkonto og vælge kortet som foretrukken betalingsmiddel.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tKortindehavers ansvars- og hæftelsesforhold\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Køb af abonnementer/produkter er bindende fra det øjeblik, der er foretaget betaling. Kortholder/kunde er forpligtet til at betale det fulde beløb for hele den valgte abonnementsperiode og efterfølgende abonnementshævninger, med mindre abonnementet i mellemtiden er opsagt jf. regler for fortrydelsesret og opsigelse nedenfor.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tFortrydelsesret og reklamation\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Hvis kunden fortryder et allerede accepteret abonnement/køb inden for 14 dage, efter det er trådt i kraft eller varen er leveret, kan kunden få tilbagebetalt det fulde beløb. Har kunden købt en vare, løber fortrydelsesretten fra leveringstidspunktet. Har kunden købt en abonnements ydelse, løber fortrydelsesretten fra bestillingstidspunktet.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Ved fortrydelse skal kunden skrive en e-mail til Leverandøren e-mailadresse og oplyse, at der ønskes at gøre brug af fortrydelsesretten. Samtidig bedes kunden oplyse nødvendige bankoplysninger (kontonummer og registreringsnummer), så leverandøren kan tilbagebetale allerede indbetalt beløb. Det er kundens ansvar at sikre at leverandør modtager fortrydelse inden fristens udløb, i henhold til ovenstående.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tOpsigelse af abonnement og bindingsperiode\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Kunden kan til enhver tid opsige det løbende abonnement. I så fald vil der ikke blive hævet penge fra betalingskortet før der oprettes et nyt abonnement. Et allerede igangværende abonnement vil blive hævet i henhold til leverandørens handelsbetingelser.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Kunden kan opsige et allerede i igangværende abonnement i kundens brugeradgang på Zietwing platformen. Alternativt kan kunden sende en e-mail til leverandøren omkring opsigelse, hvorefter leverandøren kan de-aktiverer igangværende abonnement.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Efter opsigelse forpligter Leverandøren sig ikke yderligere over for Kunden.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Abonnement, som er indbetalt, refunderes ikke. Hvis en Kunde fx betaler 1,3,6 eller 12 mdr. forud, kan dette beløb ikke refunderes. Abonnementet forlænges automatisk, medmindre Kunden opsiger aftalen skriftligt. Opsigelse af abonnement sker i overensstemmelse med leverandørens handelsbetingelser overfor kunden.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Såfremt der opstår tvivl om, hvorvidt et abonnement/ydelse er opsagt, skal kunden kunne bevise, at opsigelsen er sket korrekt.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tDataindsamling\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Zietwing platformen indsamler løbende oplysninger om brugsadfærd, når Kunden og andre brugere anvender webside eller software. Denne dataindsamling er anonym og anvendes med det formål at optimere services og indretning af softwaren. Zietwing’s Privatlivspolitik og betingelser for Zietwing kan læses på kundens brugerprofil.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tRettigheder\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Alle rettigheder omkring Zietwing platformen ejes af Zietwing, derfor Alt software, design, arkitektur, tekst o. lign. er beskyttet af ophavsretten samtidig med, at navne og egenudviklede termer er anvendte varemærker. “\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Enhver overtrædelse heraf vil blive retsforfulgt, og krav om betaling vil finde sted.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tMisligholdelse\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Al betaling fra Kunden til Leverandøren foregår som udgangspunkt ved automatisk forudbetaling eller nu og her betaling, når Kunden registrerer sit betalingskort. Såfremt betaling ikke indgår til den fastsatte forfaldsdag, vil dette kunne medføre påløb af yderligere inddrivelses omkostninger, herunder renter og rykkergebyrer, der belaster Kunden.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Såfremt sagen som et led i inddrivelsen overgives til advokat, vil advokaten eller Leverandøren kunne kræve yderligere inkassoomkostninger. Ved misligholdelse af Leverandørens Handelsbetingelser kan Leverandørens opsige samarbejdet øjeblikkeligt. Leverandøren har ret til at lukke for Kundens adgang til købte produkter, såfremt betaling ikke sker rettidigt.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tAnsvarsbegrænsning\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n          Zietwing, som ejer og drifter Zietwing betalingsplatformen tager forbehold for programmeringsfejl og servernedbrud og kan aldrig holdes økonomisk ansvarlig for eventuel nedetid, samme gældende leverandøren. I tilfælde af opdatering af software eller udstyr har Zietwing ret til at lukke for adgangen i en begrænset periode, som typisk vil ske, hvor færrest mulige Kunder vil blive påvirket af det. Zietwing kan ikke holdes ansvarlig for direkte eller indirekte tab, der er sket i forbindelse med anvendelse af Zietwing software og ydelser.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Det er Kundens eget ansvar at eftertjekke at alt er korrekt, når der trækkes abonnement på kundens betalingskort. Ved konstateret fejl kan kunden kontakte leverandøren på leverandørens e-mail adresse eller leverandørens tlf.nr. Eller tage direkte kontakt til Zietwing gennem e-mail info@zietwing.com\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Det er Kundens ansvar, at informere Leverandøren ved ændring af: adresse, telefonnummer, mailadresse, betalingskort. og andre personlige oplysninger, der måtte være tilknyttet kunden brugerkonto og som har relevans for betaling med mere.\n        "
      )
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tBetalingssikkerhed\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Alle betalingskort informationer opbevares i PCI DSS level 1 sikret betalingsgateway leveret af Zietwing. Informationer på betalingskort er udelukkende tilgængelige for betalingsgatewayens personale og derved ikke tilgængeligt for leverandøren. Al håndtering af betalingskort informationer er underlagt PCI\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tForce Majeure\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n          Zietwing eller leverandøren er ikke ansvarlig for tab, der skyldes force majeure, herunder sabotage, krig, terror, indbrud, strømsvigt, strejke, lockout, boykot, blokade, hærværk, vandskade, brand, røgskade, eksplosion eller andre omstændigheder som ligger uden for Zietwing eller Leverandøren kontrol.\n        "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("\n\t\tFortrolighedspolitik\n\t")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Leverandøren forstår og respekterer vigtigheden af privatliv på internettet.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Leverandøren vil ikke afsløre information om kunder/brugere til tredje part, med mindre det er nødvendigt for at implementere en transaktion eller loven foreskriver det.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Leverandøren vil ikke sælge dit navn, adresse, e-mail adresse, eller personlige data til tredje part uden din forudgående tilladelse.\n        "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n            Som registreret hos Leverandøren har du altid ret til at gøre indsigelse mod registreringen. Du har også ret til indsigt i, hvilke oplysninger der er registreret om dig. Disse rettigheder har du efter Persondataloven og henvendelse i forbindelse hermed rettes til Leverandøren på Leverandøren e-mailadresse, alternativt kan du i din brugerkonto læse Zietwing’s persondata politik og ligeledes anmode om indsigt.\n        "
      )
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("p", { domProps: { innerHTML: _vm._s(_vm.merchant.terms) } })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { attrs: { type: "disc" } }, [
      _c("li", [_vm._v("\n                Dankort\n            ")]),
      _vm._v(" "),
      _c("li", [_vm._v("\n                Visa/Dankort\n            ")]),
      _vm._v(" "),
      _c("li", [_vm._v("\n                Visa\n            ")]),
      _vm._v(" "),
      _c("li", [_vm._v("\n                MasterCard\n            ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [_c("strong")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8efa888c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8efa888c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentTerms.vue
// module id = /g3h
// module chunks = 1